module.exports = __webpack_public_path__ + "media/customizations/regencyatsrr/back-6dd9d06e2611c72e47a36da1f4b50e2c.jpg";